import React from 'react';
import {
  ContentLayout,
  Header,
  Container,
  Box,
  SpaceBetween
} from '@cloudscape-design/components';

const Architecture = () => {
  return (
    <ContentLayout
      header={<Header variant="h1">Architecture</Header>}
    >
      <SpaceBetween size="l">
        <Container>
          <Box textAlign="center">
            <img
              src="/architecture.png"
              alt="Title Manager Architecture"
              style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
            />
          </Box>
        </Container>
      </SpaceBetween>
    </ContentLayout>
  );
};

export default Architecture;
